import { Box, IconButton, Tabs, Tab } from "@mui/material";
import { Add } from "@mui/icons-material";
import { Sheets } from "./GridView";
import makeStyles from "@mui/styles/makeStyles";
import { connect } from "react-redux";
import { selectModeData, selectProject } from "../../redux/selectors/editor";
import { selectSheets } from "../../redux/selectors/firebase";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import {ISheetModeData} from "../../redux/slices/editor";

const useStyles = makeStyles(() => ({
    container: {
        borderTop: "1px solid rgba(224, 224, 224, 1)",
        display: "flex",
        flexDirection: "row"
    }
}));

interface Props
{
    project: string
    modeData: ISheetModeData
    sheets: Sheets
    onClickAddSheet: () => void
    onChangeActive: (event: React.ChangeEvent<{}>, newValue: string) => void
}

function SheetTabs({ modeData, sheets, project, onChangeActive, onClickAddSheet }: Props)
{
    const { sheetId } = modeData;
    const classes = useStyles();
    const { set } = useContext(FirebaseContext);

    const sheetTab = useMemo(() => Object.entries(sheets).sort(([idA, sheetA], [idB, sheetB]) => (sheetA.order ?? -1) - (sheetB.order ?? -1)), [sheets]);

    const [ordering, setOrdering] = useState<string[]>([]);

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) =>
    {
        event.preventDefault();
    }

    const handleDragStart = (event: React.DragEvent<HTMLDivElement>) =>
    {
        event.dataTransfer.setData("source", event.currentTarget.dataset.id ?? "");
    }

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) =>
    {
        event.preventDefault();
        const source = event.dataTransfer.getData("source");
        const target = event.currentTarget.dataset.id;

        if (source && source in sheets && target && target in sheets)
        {
            const targetOrder = sheets[target].order ?? 0;
            const sourceOrder = sheets[source].order ?? 0;

            setOrdering((ordering) =>
            {
                ordering.splice(sourceOrder, 1);
                ordering.splice(targetOrder, 0, source);
                return [...ordering];
            })
        }
    }

    useEffect(() =>
    {
        sheetTab.forEach(([sheetId, sheet], index) =>
        {
            if (sheet.order === undefined)
            {
                set(`sheets/${project}/${sheetId}/order`, index);
            }
        })
    }, [sheetId, sheetTab, project, set]);

    useEffect(() =>
    {
        setOrdering(Object.values(sheetTab).map(([id]) => id));
    }, [sheetTab, project, set]);

    useEffect(() =>
    {
        ordering.forEach((sheetId, order) =>
        {
            if (sheetId in sheets && sheets[sheetId].order !== order)
            {
                set(`sheets/${project}/${sheetId}/order`, order);
            }
        })
    }, [ordering, project, set, sheets]);

    return (
        <Box className={classes.container}>
            <Box style={{ alignSelf: "center" }}>
                <IconButton size={"large"} onClick={onClickAddSheet}>
                    <Add />
                </IconButton>
            </Box>
            {
                sheetId && sheetId in sheets && <Tabs variant={"scrollable"}
                    value={sheetId}
                    onChange={onChangeActive}>
                    {sheetTab.map(([id, sheet], index) =>
                        <Tab key={index}
                            value={id}
                            label={sheet.name}
                            data-id={id}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            draggable={true}
                            onDragStart={handleDragStart} />)}
                </Tabs>
            }
        </Box >
    );
}

const mapStateToProps = (store: never) => ({
    modeData: selectModeData(store),
    sheets: selectSheets(store) ?? {},
    project: selectProject(store)
});
export default connect(mapStateToProps, {
})(SheetTabs);